<template>
  <div
    class="articleDetail"
    :class="{ 'font-size-18 articleDetailPC': $store.state.innerWidth > 768 }"
  >
    <div ref="mobid">
      <MagazineDetailPopUp
        ref="magazineDetailPopUp"
        :postid="
          $store.getters.getObject(articleDetail.langMap).facebookArticleId
        "
      ></MagazineDetailPopUp>
    </div>

    <div v-if="poState">
      <Breadcrumbs class="magazine-bread"></Breadcrumbs>
      <div class="row article-contain">
        <div class="article-content">
          <div class="articleCoverContent articleCoverContentJia">
            <div
              class="articleCategory Bold"
              v-if="articleDetail.subCategoryList"
            >
              {{
                $store.getters.getContent(
                  articleDetail.subCategoryList[0].langMap
                )
              }}
            </div>
            <div class="articleTitle articleTitleJia Bold font-bold">
              {{ $store.getters.getObject(articleDetail.langMap).title }}
            </div>
            <div class="publishDate">
              {{ $t("message.Published:") }}
              {{ $store.getters.formatDate(articleDetail.publishDate) }}
            </div>
            <div class="publishDate">
              {{ $t("message.Issue") }} {{ articleDetail.issueNumber }}
              {{
                $store.getters.getObject(articleDetail.magazineLangMap).title
              }}
            </div>
          </div>
          <div class="coverImage">
            <div class="image imageJia">
              <img :src="$store.getters.getObject(articleDetail.langMap).coverPhoto" :alt="$store.getters.getObject(articleDetail.langMap).title"/>
            </div>
            <!-- <div class="caption">
                        {{$store.getters.getObject(articleDetail.langMap).coverPhotoCaption}}
            </div>-->
          </div>
          <div
            class="editorContent"
            v-if="$store.getters.getObject(articleDetail.langMap).content"
          >
            <!-- <ckeditor
              :editor="editor"
              :disabled="false"
              :isReadOnly="false"
              :config="editorConfig"
              tag-name="textarea"
              :value="$store.getters.getObject(articleDetail.langMap).content"
            ></ckeditor> -->
            <div
              v-html="
                modifyVideo(
                  $store.getters.getObject(articleDetail.langMap).content
                )
              "
            ></div>
          </div>
          <div
            class="defaultSwiper"
            v-if="
              $store.getters.getObject(articleDetail.langMap).imageCaption &&
              $store.getters.getObject(articleDetail.langMap).imageCaption
                .length
            "
          >
            <SwiperDefault
              :imglist="
                $store.getters.getObject(articleDetail.langMap).imageCaption
              "
            ></SwiperDefault>
          </div>
          <div class="readMore readMoreJia" v-if="articleList.length > 0">
            <div class="readMoreTitle Bold">{{ $t("message.Read more:") }}</div>
            <div class="readMoreContent">
              <a
                v-for="(article, index) in articleList"
                v-if="
                  (index < 3 || showMore || $store.state.innerWidth > 768) &&
                  $route.params.id != article.id
                "
                v-bind:href="
                  '../onlineMagazineDetail/' +
                  article.id +
                  '?lang=' +
                  $store.state.language +
                  '&name=' +
                  $store.getters.replaceEvent($store.getters.getObject(article.langMap).title)
                "
              >
                <span class="listText-iner-magazineDetail">{{
                  $store.getters.getObject(article.langMap).title
                }}</span>
              </a>
            </div>
          </div>
          <div class="border" v-if="$store.state.innerWidth <= 768"></div>
          <div class="more" v-if="$store.state.innerWidth <= 768">
            <div
              class="moreBtn"
              v-if="articleList.length > 2"
              @click="showMore = !showMore"
            >
              <span v-if="!showMore" class="SemiBold">{{
                $t("message.Show more")
              }}</span>
              <span v-if="showMore" class="SemiBold">{{
                $t("message.Show less")
              }}</span>
              <span class="pad-lr-10">
                <i class="icon-arrow-down" :class="{ tran180: showMore }"></i>
              </span>
            </div>
          </div>
          <div
            class="tagsOption tagsOptionJia"
            v-if="
              $store.getters.getObject(articleDetail.langMap).tags &&
              $store.getters.getObject(articleDetail.langMap).tags.length > 0
            "
          >
            <div
              class="tag"
              v-for="tag in $store.getters.getObject(articleDetail.langMap)
                .tags"
              v-if="tag != ''"
            >
              {{ tag }}
            </div>
          </div>
          <div class="border"></div>
          <div
            class="authorInfo authorInfoJia"
            v-if="
              $store.getters.getObject(articleDetail.langMap).authorIcon !=
                null ||
              $store.getters.getObject(articleDetail.langMap).authorName !=
                null ||
              $store.getters.getObject(articleDetail.langMap).authorTitle !=
                null
            "
          >
            <div class="item-table">
              <div
                class="tdcell icon"
                v-if="
                  $store.getters.getObject(articleDetail.langMap).authorIcon !=
                  null
                "
              >
                <img
                  :src="
                    $store.getters.getObject(articleDetail.langMap).authorIcon
                  "
                />
              </div>
              <div class="tdcell info">
                <p class="name Bold">
                  {{
                    $store.getters.getObject(articleDetail.langMap).authorName
                  }}
                </p>
                <p class="authorTitle authorTitle-magazineDetail">
                  {{
                    $store.getters.getObject(articleDetail.langMap).authorTitle
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="share shareJia" style="padding-bottom: 50px">
            <ShareBar v-if="showShareBar"></ShareBar>
          </div>
          <div class="viewComments viewCommentsJia" v-if="$store.getters.getObject(articleDetail.langMap).facebookArticleId">
            <div class="item-table mainColor viewComment-info" >
              <div class="tdcell icon viewComment-icon" @click="viewComment">
                <i class="icon-message"></i>
              </div>
              <div class="tdcell label label-magazineDtailJia Bold" @click="viewComment">
                <p class="name">{{$t('message.View Comments')}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div
          class="similar"
          v-if="
            articleDetail.recommendedArticlesList &&
            articleDetail.recommendedArticlesList.length > 0
          "
        >
          <div class="article-contain articles row">
            <div class="similar-content">
              <div class="mainColor box-img-bg box-magazineDetailJia Bold">
                <h2>
                  {{ $t("message.Recommended articles") }}
                  <img class="noSelect" src="../images/deco-10.png" />
                </h2>
              </div>
              <SwiperArticles
                v-bind:childLogGaEvent="childLogGaEvent"
                :init="init"
                :data="articleDetail.recommendedArticlesList"
              ></SwiperArticles>
            </div>
          </div>
        </div>
        <div
          class="similar"
          v-if="
            articleDetail.subCategoryList &&
            articleDetail.subCategoryList[0].categoryId != 3
          "
        >
          <div class="article-contain relatedOccupations">
            <div class="similar-content">
              <div class="mainColor box-img-bg box-magazineDetailJia Bold">
                <h2>
                  {{ $t("message.Related Occupations") }}
                  <img
                    class="noSelect"
                    src="../images/Vector Smart Object20.png"
                  />
                </h2>
              </div>
              <SwiperOccupations
                v-bind:childLogGaEvent="childLogGaEvent"
                :init="init"
                :data="articleDetail.occupationList"
              ></SwiperOccupations>
              <div class="center online-Detail-viewAll">
                <div
                  class="btn btn-primary"
                  @click="goOccupation"
                  v-if="articleDetail.occupationList && articleDetail.occupationList.length > 5"
                  role="button"
                  :aria-label='$t("message.View all")'
                >
                  <a href="javascript:;" style="color: inherit">{{ $t("message.View all") }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="imgGroup">
        <img class="img1 noSelect" src="../images/BG deco.png" />
        <img class="img2 noSelect" src="../images/deco-10.png" />
        <img class="img3 noSelect" src="../images/deco-27.png" />
        <img class="img4 noSelect" src="../images/deco-17.png" />
      </div>
    </div>
  </div>
</template>
<style >
.videoWrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
}
.videoWrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import SwiperDefault from "@/components/SwiperDefault.vue";
import SwiperArticles from "@/components/SwiperArticles.vue";
import SwiperOccupations from "@/components/SwiperOccupations.vue";
import MagazineDetailPopUp from "@/components/magazineDetailPopUp.vue";
import ShareBar from "@/components/ShareBar.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { EventBus } from "@/javascripts/eventBus.js";

import Vue from "vue";
import CKEditor from "@ckeditor/ckeditor5-vue";
Vue.use(CKEditor);

export default {
  name: "onlineMagazineDetail",
  data() {
    return {
      articleDetail: {
        occupationList: [],
        langMap: [],
      },
      articleList: [],
      showMore: false,
      editor: ClassicEditor,
      scrollTop: 0,
      editorConfig: {
        toolbar: [],
      },
      fromLouterName: "",
      poState: true,
      louterState: false,
      showShareBar: false,
    };
  },
  components: {
    Breadcrumbs,
    SwiperDefault,
    SwiperArticles,
    SwiperOccupations,
    ShareBar,
    MagazineDetailPopUp,
  },
  props: ["logGaEvent"],
  methods: {
    modifyVideo: function (url) {
      let endpoint = url;
      endpoint = endpoint.replace(
        "<oembed",
        '<div class="videoWrapper"><iframe  frameborder="0" height="100%" width="100%" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen'
      );
      endpoint = endpoint.replace("url", "src");
      endpoint = endpoint.replace("watch?v=", "embed/");
      endpoint = endpoint.replace(
        "https://youtu.be/",
        "https://www.youtube.com/embed/"
      );
      endpoint = endpoint.replace("oembed", "iframe></div");
      return endpoint;
    },
    childLogGaEvent: function (
      eventCategory,
      eventAction,
      eventLabel,
      eventValue
    ) {
      this.logGaEvent(eventCategory, eventAction, eventLabel, eventValue);
    },
    changeScrollTop: function () {
      var that = this;
      if (this.$store.state.innerWidth <= 992) {
        setTimeout(() => {
          document.documentElement.scrollTop = that.scrollTop;
        }, 300);
      }
    },
    getScrollTop: function () {
      if (this.$store.state.innerWidth <= 992) {
        this.scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
      }
    },
    changeContentShowFoorter: function () {
      this.$parent.changeShowFoorter();
    },
    changeContentHideFoorter: function () {
      this.$parent.changeHideFoorter();
    },
    showPoState: function () {
      this.poState = true;
    },
    hidePoState: function () {
      if (this.$store.state.innerWidth <= 992) {
        this.poState = false;
      }
    },
    viewComment: function () {
      if (this.$store.state.isPreview) {
        return;
      }
      this.getScrollTop();

      this.logGaEvent("userClick", "viewComment", "viewComment");
      //
      if (this.$refs.magazineDetailPopUp)
        this.$refs.magazineDetailPopUp.showMenu();
      this.$parent.changeHideFoorter();
      this.showMobid();
      this.hidePoState();
    },
    showMobid: function () {
      if (this.$store.state.innerWidth <= 992) {
        this.$refs.mobid.style.height = window.innerHeight - 53 + "px";
      }
    },
    hideMobid: function () {
      this.$refs.mobid.style.height = 0 + "px";
    },
    getArticleDetail: function (id) {
      var that = this;
      this.showShareBar = false;
      this.api.getArticleDetail(
        {
          articleId: id,
        },
        function (data) {
          that.articleDetail = data.result;
          that.getArticleList();
          that.showShareBar = true;
          for (var i = 0; i < that.articleDetail.langMap.length; i++) {
            that.articleDetail.langMap[i].imageCaption = JSON.parse(
              that.articleDetail.langMap[i].imageCaption
            );
            that.articleDetail.langMap[i].tags = that.articleDetail.langMap[
              i
            ].tags.split(",");
          }
          that.setBreadcrumbs();
        }
      );
    },
    getArticleDetailPreview: function (id) {
      var that = this;
      this.api.getArticleDetailPreview(
        {
          articleId: id,
        },
        function (data) {
          that.articleDetail = data.result;
          that.getArticleList();

          for (var i = 0; i < that.articleDetail.langMap.length; i++) {
            that.articleDetail.langMap[i].imageCaption = JSON.parse(
              that.articleDetail.langMap[i].imageCaption
            );
            that.articleDetail.langMap[i].tags = that.articleDetail.langMap[
              i
            ].tags.split(",");
          }
        }
      );
    },
    getArticleList: function () {
      let that = this;
      this.api.getIssueContent(
        { magazineId: that.articleDetail.magazineId },
        function (data) {
          that.articleList = [];
          for (var i = 0; i < data.result.length; i++) {
            for (var j = 0; j < data.result[i].articleList.length; j++) {
              if (that.$route.params.id != data.result[i].articleList[j].id) {
                that.articleList.push(data.result[i].articleList[j]);
              }
            }
          }
        }
      );
    },
    init: function () {
      this.articleDetail = {};
      if (this.$store.state.isPreview) {
        this.getArticleDetailPreview(this.$route.params.id);
      } else {
        this.getArticleDetail(this.$route.params.id);
      }
    },
    setBreadcrumbs: function () {
      if (this.$route.path.indexOf("onlineMagazineDetail") > 0) {
        var breadcrumbs = this.$route.meta.breadcrumbs.find(
          (b) => b.to.indexOf("magazine") > 0 && b.isData
        );
        if (breadcrumbs) {
          breadcrumbs.text =
            this.$i18n.t("message.Issue") +
            " " +
            this.articleDetail.issueNumber +
            " " +
            this.$store.getters.getObject(this.articleDetail.magazineLangMap)
              .title;
        }
        breadcrumbs.to = "/magazine/" + this.articleDetail.magazineId;
        var breadcrumbs = this.$route.meta.breadcrumbs.find(
          (b) => b.to.indexOf("onlineMagazineDetail") > 0
        );
        if (breadcrumbs) {
          document.title = this.$store.state.mate.title = breadcrumbs.text = this.$store.getters.getObject(
            this.articleDetail.langMap
          ).title;
          breadcrumbs.to = "/onlineMagazineDetail/" + this.$route.params.id;
        }
        this.$store.state.mate.description = this.$store.getters.getObject(
          this.articleDetail.langMap
        ).shortDescription;
        this.$store.state.mate.image = this.$store.getters.getObject(
          this.articleDetail.langMap
        ).coverPhoto;
        this.$store.state.mate.keywords = this.$store.getters.getObject(
          this.articleDetail.langMap
        ).tags;
        if (this.$store.state.mate.image.indexOf(".jpg") > 0) {
          this.$store.state.mate.imageType = "image/jpg";
        } else if (this.$store.state.mate.image.indexOf(".jpeg") > 0) {
          this.$store.state.mate.imageType = "image/jpeg";
        }
      }
    },
    goOccupation: function () {
      if (this.$store.state.isPreview) {
        return;
      }
      this.logGaEvent("userClick", "goOccupation", "Related occupation");
      this.$router.push({
        path: "/RelatedOccupations/" + this.$route.params.id,
        query: { lang: this.$store.state.language },
      });
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    //
    this.$store.state.mate.width = 1000;
    this.$store.state.mate.height = 800;
    if (this.$route.params.preview == "preview") {
      this.$store.state.isPreview = true;
    }
    if (
      this.$refs.magazineDetailPopUp &&
      this.$refs.magazineDetailPopUp.numMove == 0
    ) {
      // this.hideMobid();
      this.$refs.mobid.style.height = 0 + "px";
    }

    this.$store.state.selectMenu = 1;
    this.init();
    // if(this.louterState){

    //   setTimeout(()=>{

    //       window.scrollTo(0,that.$store.state.formData.onlineMagazineScroll);
    //   },400)
    // }
  },
  activated() {
    this.$store.state.mate.width = 1000;
    this.$store.state.mate.height = 800;
    if (!this.$route.meta.isUseCache) {
      this.init();
      window.scrollTo(0, 0);
    }
  },
  computed: {
    innerwidth() {
      return this.$store.state.innerWidth;
    },
    _language() {
      return this.$store.state.language;
    },
    magazineid() {
      return this.$route.params.id;
    },
  },
  watch: {
    _language: {
      handler: function (val, oldVal) {
        this.$store.state.mate.width = 1000;
        this.$store.state.mate.height = 800;
        if (this.$route.path.indexOf("onlineMagazineDetail") > 0) {
          // this.$router.push({query: {lang: val,name:this.$store.getters.replaceEvent(this.$store.getters.getObject(this.articleDetail.langMap).title)}})
        }
        this.setBreadcrumbs();
      },
      deep: true,
    },
    magazineid: {
      handler: function (val, oldVal) {
        if (
          this.$route.params.id &&
          this.$route.path.indexOf("onlineMagazineDetail") > 0
        ) {
          this.init();
        }
      },
      deep: true,
    },
    innerwidth() {
      this.hideMobid();

      if (this.$store.state.innerWidth > 992) {
        this.poState = true;
        this.hideMobid();
        this.changeContentShowFoorter();
      } else if (this.$store.state.innerWidth <= 992) {
        if (this.$refs.magazineDetailPopUp.isShowMenu == true) {
          this.changeContentHideFoorter();
          this.hidePoState();
        } else {
          this.hideMobid();
        }
      }
    },
  },
};
</script>